import { FieldLayout } from "./ReportContext";
export class BillingReport {
   static parse(source: any = {}): BillingReport {
      return new BillingReport(
         source["id"] || Math.round(Math.random() * Math.pow(2, 32)), // used by the key attribute
         source["instanceName"],
         source["reportDate"],
         source["programName"],
         source["officeName"],
         source["activeUsers"],
         source["maxUsers"],
         source["activePatients"],
         source["maxPatients"],
         source["billableMinutes"]
      );
   }
   constructor(
      readonly id: number,
      readonly instanceName: string,
      readonly reportDate: string,
      readonly programName: string,
      readonly officeName: string,
      readonly activeUsers: number,
      readonly maxUsers: number,
      readonly activePatients: number,
      readonly maxPatients: number,
      readonly billableMinutes: number
   ) {}
   hasData = () => this.billableMinutes != undefined;
   static getLayout(): FieldLayout[] {
      return FIELD_LAYOUT;
   }
}
export const FIELD_LAYOUT: FieldLayout[] = [
   { label: "Instance Name", toString: (item) => item["instanceName"], styleHint: null },
   { label: "Report Date", toString: (item) => item["reportDate"], styleHint: null },
   {
      label: "Users",
      toString: (item) => item["activeUsers"] + " of " + item["maxUsers"],
      styleHint: { textAlign: "right" },
   },
   {
      label: "Patients",
      toString: (item) => item["activePatients"] + " of " + item["maxPatients"],
      styleHint: { textAlign: "right" },
   },
   { label: "Program", toString: (item) => item["programName"], styleHint: null },
   { label: "Office", toString: (item) => item["officeName"], styleHint: null },
   {
      label: "Hours",
      toString: (item) =>
         "" +
         ((item as BillingReport)["billableMinutes"] != undefined
            ? (Math.round((item as BillingReport)["billableMinutes"] / 6) / 10).toFixed(1)
            : ""),
      styleHint: { textAlign: "right" },
   },
];
